import type { EnrollInstructionStep } from "../../_types/enroll.types";
import styles from "./EnrollmentInstructions.module.scss";

type EnrollmentInstructionsProps = {
  steps: EnrollInstructionStep[];
};

export const EnrollmentInstructions = ({ steps }: EnrollmentInstructionsProps) => {
  return (
    <div className={styles["comp"]}>
      <ul className={styles["comp__steps"]}>
        {steps.map((step) => (
          <li key={step.title} className={styles["comp__step"]}>
            <span className={styles["comp__bullet"]} aria-hidden />
            <div className={styles["comp__main"]}>
              <div className={styles["comp__title"]}>{step.title}</div>
              <div className={styles["comp__body"]}>{step.body}</div>
              {step.callout ? <div className={styles["comp__callout"]}>{step.callout}</div> : null}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
